var map = {
	"./admin.svg": "109b",
	"./dots-grid.svg": "9977",
	"./grid.svg": "a7be",
	"./people.svg": "a4db",
	"./plus.svg": "b5ee",
	"./stats.svg": "59da"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "630d";